import { render } from "./AddRightsModal.vue?vue&type=template&id=3935dc69"
import script from "./AddRightsModal.vue?vue&type=script&lang=js"
export * from "./AddRightsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__